import React, { useEffect } from 'react';
import MuiThemeProvider from '@material-ui/core/styles/MuiThemeProvider';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import { createMuiTheme } from '@material-ui/core/styles';


const customTheme = createMuiTheme({
  typography: {
    useNextVariants: true,
  },
  overrides: {
    MuiBackdrop: {
      root: {
        backgroundColor: 'unset',
      },
    },

    MuiDialogContent: {
      root: {
        // borderRadius: '25px',
      },
    },
    MuiPaper: {
      rounded: {
        borderRadius: '25px',
      },
    },
  },
});
function Message(props) {
  useEffect(() => {
    setTimeout(() => {
      props.handleClose();
    }, 3000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = () => {
    props.handleClose();
  };

  return (
    <div>
      <MuiThemeProvider theme={customTheme}>
        <Dialog
          open={props.open}
          onClose={() => handleClose()}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          style={{ opacity: 0.6 }}
        >
          <DialogContent style={{ backgroundColor: 'var(--black)' }} onClick={() => handleClose()}>
            <span style={{ color: 'var(--white)', fontWeight: 'bold', lineHeight: 'normal' }}>{props.alertmessage}</span>
          </DialogContent>
        </Dialog>
      </MuiThemeProvider>
    </div>
  );
}

export default Message;
